<template>
  <div class="warrantyStatement-wrap">
    <div class="title" v-if="show">
      <span class="title-text">保障申明</span>
    </div>
   <div class="list-wrap">
    <div v-for="item in warrantyStatementList" :key="item.id" class="item">
      <img :src="item.icon" alt="">
      <div class="text">
        <div class="name">{{item.name}}</div>
        <div class="desc">{{item.desc}}</div>
      </div>
    </div>
   </div>
  </div>
</template>

<script>
import { warrantyStatementList } from '@/utils/const'
export default {
  components: {},
  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },
  name: "WarrantyStatement",
  data() {
    return {
        warrantyStatementList,
        
    };
  },
  methods: {},
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
};
</script>

<style scoped lang="scss">
.warrantyStatement-wrap {
  padding: 20px;
  background: #fff;
  border-radius: 12px;
}
.title{
  display: flex;
  flex-direction: column;
  align-items: center;
  .title-text{
    font-size: 16px;
    color: #333;
    border-bottom: 5px solid #1D70F7;
  }
  .title-desc{
    font-size: 12px;
    color: #999;
    margin-top: 12px;
  }
}
.list-wrap {
  display: flex;
  flex-direction: column;
}
.item {
  display: flex;
  margin-top: 14px;
  align-items: center;
  flex: 1;
  justify-content: center;
}
.item img {
  height: 28px;
  padding-right: 15px;
}
.item .text .name {
  font-size: 14px;
}
.item .text .desc {
  font-size: 12px;
  color: #999;
}
</style>
